import { Route } from 'react-router-dom';

import { DailyRatesPage } from './pages/daily-rates-page.js';

export function dailyRateRoutes(): React.JSX.Element {
  return <Route path="/daily-rates" element={<DailyRatesPage />} />;
}
